// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/support/v1/support_addons.proto (package gportal.api.support.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Money } from "../../../type/v1/money_pb.js";

/**
 * @generated from enum gportal.api.support.v1.SupportAddonStatus
 */
export enum SupportAddonStatus {
  /**
   * @generated from enum value: SUPPORT_ADDON_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORT_ADDON_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: SUPPORT_ADDON_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: SUPPORT_ADDON_STATUS_DECLINED = 3;
   */
  DECLINED = 3,

  /**
   * @generated from enum value: SUPPORT_ADDON_STATUS_PROCESSING = 4;
   */
  PROCESSING = 4,

  /**
   * @generated from enum value: SUPPORT_ADDON_STATUS_AUTHORIZED = 5;
   */
  AUTHORIZED = 5,

  /**
   * @generated from enum value: SUPPORT_ADDON_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(SupportAddonStatus)
proto3.util.setEnumType(SupportAddonStatus, "gportal.api.support.v1.SupportAddonStatus", [
  { no: 0, name: "SUPPORT_ADDON_STATUS_UNSPECIFIED" },
  { no: 1, name: "SUPPORT_ADDON_STATUS_PENDING" },
  { no: 2, name: "SUPPORT_ADDON_STATUS_APPROVED" },
  { no: 3, name: "SUPPORT_ADDON_STATUS_DECLINED" },
  { no: 4, name: "SUPPORT_ADDON_STATUS_PROCESSING" },
  { no: 5, name: "SUPPORT_ADDON_STATUS_AUTHORIZED" },
  { no: 6, name: "SUPPORT_ADDON_STATUS_CANCELLED" },
]);

/**
 * @generated from enum gportal.api.support.v1.SupportAddonPaymentOperationStatus
 */
export enum SupportAddonPaymentOperationStatus {
  /**
   * @generated from enum value: SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_FAILED = 1;
   */
  FAILED = 1,

  /**
   * @generated from enum value: SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_SUCCESSFUL = 2;
   */
  SUCCESSFUL = 2,

  /**
   * @generated from enum value: SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_PENDING = 3;
   */
  PENDING = 3,

  /**
   * @generated from enum value: SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_CANCELLED = 4;
   */
  CANCELLED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(SupportAddonPaymentOperationStatus)
proto3.util.setEnumType(SupportAddonPaymentOperationStatus, "gportal.api.support.v1.SupportAddonPaymentOperationStatus", [
  { no: 0, name: "SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_UNSPECIFIED" },
  { no: 1, name: "SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_FAILED" },
  { no: 2, name: "SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_SUCCESSFUL" },
  { no: 3, name: "SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_PENDING" },
  { no: 4, name: "SUPPORT_ADDON_PAYMENT_OPERATION_STATUS_CANCELLED" },
]);

/**
 * @generated from enum gportal.api.support.v1.SupportAddonType
 */
export enum SupportAddonType {
  /**
   * @generated from enum value: SUPPORT_ADDON_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORT_ADDON_TYPE_PREMIUM_SUPPORT = 1;
   */
  PREMIUM_SUPPORT = 1,

  /**
   * @generated from enum value: SUPPORT_ADDON_TYPE_PRIORITY_SUPPORT = 2;
   */
  PRIORITY_SUPPORT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SupportAddonType)
proto3.util.setEnumType(SupportAddonType, "gportal.api.support.v1.SupportAddonType", [
  { no: 0, name: "SUPPORT_ADDON_TYPE_UNSPECIFIED" },
  { no: 1, name: "SUPPORT_ADDON_TYPE_PREMIUM_SUPPORT" },
  { no: 2, name: "SUPPORT_ADDON_TYPE_PRIORITY_SUPPORT" },
]);

/**
 * @generated from message gportal.api.support.v1.SupportAddon
 */
export class SupportAddon extends Message<SupportAddon> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gportal.api.support.v1.SupportAddonType type = 2;
   */
  type = SupportAddonType.UNSPECIFIED;

  /**
   * @generated from field: gportal.api.support.v1.SupportAddonStatus status = 3;
   */
  status = SupportAddonStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<SupportAddon>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.SupportAddon";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(SupportAddonType) },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(SupportAddonStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupportAddon {
    return new SupportAddon().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupportAddon {
    return new SupportAddon().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupportAddon {
    return new SupportAddon().fromJsonString(jsonString, options);
  }

  static equals(a: SupportAddon | PlainMessage<SupportAddon> | undefined, b: SupportAddon | PlainMessage<SupportAddon> | undefined): boolean {
    return proto3.util.equals(SupportAddon, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.SupportAddonSettings
 */
export class SupportAddonSettings extends Message<SupportAddonSettings> {
  /**
   * @generated from field: gportal.api.support.v1.SupportAddonType type = 1;
   */
  type = SupportAddonType.UNSPECIFIED;

  /**
   * @generated from field: bool is_enabled = 2;
   */
  isEnabled = false;

  /**
   * @generated from field: optional string disable_reason_loco_key = 3;
   */
  disableReasonLocoKey?: string;

  constructor(data?: PartialMessage<SupportAddonSettings>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.SupportAddonSettings";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(SupportAddonType) },
    { no: 2, name: "is_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "disable_reason_loco_key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupportAddonSettings {
    return new SupportAddonSettings().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupportAddonSettings {
    return new SupportAddonSettings().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupportAddonSettings {
    return new SupportAddonSettings().fromJsonString(jsonString, options);
  }

  static equals(a: SupportAddonSettings | PlainMessage<SupportAddonSettings> | undefined, b: SupportAddonSettings | PlainMessage<SupportAddonSettings> | undefined): boolean {
    return proto3.util.equals(SupportAddonSettings, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.SupportAddonPrices
 */
export class SupportAddonPrices extends Message<SupportAddonPrices> {
  /**
   * @generated from field: gportal.api.support.v1.SupportAddonType type = 1;
   */
  type = SupportAddonType.UNSPECIFIED;

  /**
   * @generated from field: map<string, gportal.type.v1.Money> prices = 2;
   */
  prices: { [key: string]: Money } = {};

  /**
   * @generated from field: map<string, gportal.type.v1.Money> discounted_prices = 3;
   */
  discountedPrices: { [key: string]: Money } = {};

  /**
   * @generated from field: optional string reason_for_discounted_prices_loco_key = 4;
   */
  reasonForDiscountedPricesLocoKey?: string;

  /**
   * @generated from field: optional int32 remaining_free_tickets = 5;
   */
  remainingFreeTickets?: number;

  constructor(data?: PartialMessage<SupportAddonPrices>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.SupportAddonPrices";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(SupportAddonType) },
    { no: 2, name: "prices", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Money} },
    { no: 3, name: "discounted_prices", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Money} },
    { no: 4, name: "reason_for_discounted_prices_loco_key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "remaining_free_tickets", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupportAddonPrices {
    return new SupportAddonPrices().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupportAddonPrices {
    return new SupportAddonPrices().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupportAddonPrices {
    return new SupportAddonPrices().fromJsonString(jsonString, options);
  }

  static equals(a: SupportAddonPrices | PlainMessage<SupportAddonPrices> | undefined, b: SupportAddonPrices | PlainMessage<SupportAddonPrices> | undefined): boolean {
    return proto3.util.equals(SupportAddonPrices, a, b);
  }
}

